import { useQuery } from '@tanstack/react-query';
import { getPositionDetails } from '@/api/getPositionDetails';
import { DetailedPosition } from '@/interfaces/Menu';

export const usePositionDetails = (menuId: string, positionId: string, language: string) => {
  return useQuery<DetailedPosition>({
    queryKey: ['positionDetails', menuId, positionId, language],
    queryFn: () => getPositionDetails(menuId, positionId, language),
    enabled: !!menuId && !!positionId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
